const ASPECT_RATIO_TOLERANCE = 0.02;

export const readImageDimensions = (file) =>
    new Promise((resolve) => {
        const url = URL.createObjectURL(file);
        const image = new Image();
        image.onload = () => {
            URL.revokeObjectURL(url);
            resolve({
                width: image.naturalWidth,
                height: image.naturalHeight
            });
        };
        image.onerror = () => {
            URL.revokeObjectURL(url);
            resolve({ width: 0, height: 0 });
        };
        image.src = url;
    });

export const validateAspectRatio = async (file, { height, strict, width }) => {
    const recommended = { width, height };
    if (!strict) {
        return { valid: true, expectedRatio: null, recommended, actual: null };
    }
    const dimensions = await readImageDimensions(file);
    const expectedRatio = width / height;
    // SVG u otros formatos sin dimensiones intrínsecas: no bloquear
    if (!dimensions.width || !dimensions.height) {
        return { valid: true, expectedRatio, recommended, actual: null };
    }
    const actualRatio = dimensions.width / dimensions.height;
    const valid =
        Math.abs(actualRatio - expectedRatio) / expectedRatio <=
        ASPECT_RATIO_TOLERANCE;
    return { valid, expectedRatio, recommended, actual: dimensions };
};

const greatestCommonDivisor = (a, b) =>
    b ? greatestCommonDivisor(b, a % b) : a;

// Proporción legible (3:1, 16:9); null si al reducirla queda con números
// que no le dicen nada al tenant (ej. 683:384).
const MAX_READABLE_RATIO_TERM = 32;
export const formatAspectRatio = ({ height, width }) => {
    if (!width || !height) return null;
    const divisor = greatestCommonDivisor(width, height);
    const ratioWidth = width / divisor;
    const ratioHeight = height / divisor;
    if (
        ratioWidth > MAX_READABLE_RATIO_TERM ||
        ratioHeight > MAX_READABLE_RATIO_TERM
    ) {
        return null;
    }
    return `${ratioWidth}:${ratioHeight}`;
};

const formatSize = ({ height, width }) => `${width} × ${height} px`;

export const aspectErrorMessage = ({ actual, expectedRatio, recommended }) => {
    const recommendedSize = formatSize(recommended);
    const ratio = formatAspectRatio(recommended);
    const expected =
        expectedRatio === 1
            ? "La imagen debe ser cuadrada (proporción 1:1)."
            : ratio
            ? `La imagen debe tener proporción ${ratio}.`
            : `La imagen debe tener la misma proporción que ${recommendedSize}.`;
    const uploaded =
        actual && actual.width && actual.height
            ? ` Tu imagen mide ${formatSize(actual)}.`
            : "";
    return `${expected} Medida recomendada: ${recommendedSize}.${uploaded}`;
};
